import(/* webpackMode: "eager" */ "/ibznts/src/app/solution/utm/fence/page.tsx");
